exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-page .device-list-toggle{display:none;padding:10px}.home-page .content{max-height:calc(100vh - 64px);overflow-y:auto}@media (min-width:992px){.home-page .device-list-container{max-height:calc(100vh - 64px);overflow-y:auto}}@media (max-width:991.98px){.home-page .device-list-container{max-height:400px;overflow-y:auto}.home-page .device-list-toggle,.home-page .device-list.device-list-toggle-on{display:block}.home-page .device-list.device-list-toggle-off{display:none}}", ""]);

// exports
